/**
 * dialog ids for user tree
 * todo we might want to rename this to staff-tree-dialog-id-constants.ts or something like this
 */
// TODO can't we use DialogId enum from openapi types?
export const DIALOG_PLANNING_CHART = "PLANNING_CHART";
export const DIALOG_TIME_ACCOUNT = "TIMEACCOUNT";
export const DIALOG_ID_DEFAULT = "DEFAULT";
export const DIALOG_ID_WORKFORCE_MANAGEMENT = "WORKFORCE_MANAGEMENT";
export const DIALOG_ID_STATUS_CHART = "STATUS_CHART";
export const DIALOG_ID_REPORTING = "REPORTING";
export const DIALOG_ID_FASTDESK = "FASTDESK";
